import { render, staticRenderFns } from "./ApprovalNotif.vue?vue&type=template&id=6f5500b4"
import script from "./ApprovalNotif.vue?vue&type=script&lang=js"
export * from "./ApprovalNotif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports